<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="2">
             <div class="label">店铺</div>
            </el-col>
            <el-col :span="10">
              <el-select v-model="s_shop_name" size="small" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <div class="label">商品名称</div>
            </el-col>
            <el-col :span="7">
              <div class="goodslost_seach_row_col">
                <el-input placeholder="商品名称" v-model="s_name" clearable style="width:190px" size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="label">货号</div>
            </el-col>
            <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <el-input placeholder="货号" v-model="s_item_no" clearable style="width:190px" size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="8" style="text-align:center">
              <div>
                <el-button size="small" @click="seach()">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      > 
        <el-table-column align="center" type="selection"  width="55"></el-table-column>
        <el-table-column align="center" prop="shop_name" label="店铺" width="100"></el-table-column>
        <el-table-column align="center" prop="title" label="商品" width="120"></el-table-column>
        <el-table-column
          align="center"
          prop="item_no"
          label="货号"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="brand" label="品牌"></el-table-column>
        <el-table-column align="center" prop="specification" label="规格" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="top_class" label="分类" ></el-table-column>

        <el-table-column width="180" align="center" label="操作">
          <template slot-scope="scope">
            <span class="binaji" @click="change_audit(scope.row.id)">通过</span>
            <span class="binaji" @click="change_return(scope.row.id)">驳回</span>
            <span class="binaji" @click="dialogFormVisible = true,view(scope.row.id)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="background: #fff;">
        <el-button size="small" @click="mutiAudit" class="mutiAuth">批量通过</el-button>
        <el-pagination
          class="goodslist_bom_page"
          hide-on-single-page
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
      <el-dialog title="商品详情" :visible.sync="dialogFormVisible" width="30%">
      <el-form>
        <el-form-item label="商品名称:">
          {{tableInfo.title}}
        </el-form-item>
        <el-form-item label="常用名称:">
          {{tableInfo.common_title}}
        </el-form-item>
        <el-form-item label="品牌:">
          {{tableInfo.brand}}
        </el-form-item>
        <el-form-item label="货号:">
          {{tableInfo.item_no}}
        </el-form-item>
        <el-form-item label="货期:">
          {{tableInfo.leadtime}}
        </el-form-item>
        <el-form-item label="规格:">
          {{tableInfo.specification}}
        </el-form-item>
        <el-form-item label="型号:">
          {{tableInfo.model}}
        </el-form-item>
        <el-form-item label="应用:">
          {{tableInfo.uses}}
        </el-form-item>
        <el-form-item label="库存:">
          {{tableInfo.inventory}}
        </el-form-item>
        <el-form-item label="售价:">
          {{tableInfo.selling_price}}
        </el-form-item>
        <el-form-item label="原价:">
          {{tableInfo.original_price}}
        </el-form-item>
        <el-form-item label="图片:">
           <img :src="serve + tableInfo.images">
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    </div>
    
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      role: true, 
      serve: this.$store.state.serve,
      sy_name: "",
      loading: false,
      shop_name: "",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      id: '',
      s_shop_name: '',
      s_name: '',
      s_item_no: '',
      options: [],
      tableInfo: [],
      dialogFormVisible: false,
      multipleSelection: [],
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "待审核商品";
    this.shopSearchList();
    this.geting();
  },
  watch: {},
  methods: {
    change_audit(id) {
      const pid = JSON.stringify(id.split(","));
      this.$confirm("此操作将使该商品上架, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/checkProduct", {
              params: {
                username: this.username,
                token: this.token,
                id: pid
              }
            })
            .then(res => {
              this.geting()
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
                this.geting()
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg);  
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核"
          });
        });
    },
    mutiAudit(){ //批量审核
      let that = this;
      let selectData = that.multipleSelection;
      if(selectData.length == 0){
        that.$message({
            type: "warning",
            message: "请先勾选你要操作的选项！"
        });
        return;
      }
      let ids = [];
      for(let key in selectData){
        ids.push(selectData[key]['id']);
      }
      this.$confirm("此操作将使被勾选的商品上架, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/checkProduct", {
              params: {
                username: this.username,
                token: this.token,
                id: JSON.stringify(ids)
              }
            })
            .then(res => {
              this.geting()
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
                this.geting()
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg);  
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消审核"
          });
        });
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    checkname(row, column, rowIndex, columnIndex){
        if(row.rowIndex == 0){
          return 'firstline'
        }
    },
    change_return (id) { 
        this.$prompt('请填写驳回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请填写审核驳回的理由！'
        }).then(({ value }) => {
           this.axios
            .get(this.serve + "/admin/rejectProduct", {
              params: {
                username: this.username,
                token: this.token,
                id: id,
                reson: value
              }
            })
            .then(res => {
            
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
                this.geting()
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg);  
              } else if (res.data.status == "error") {
                this.$message.error(res.data.msg);
              }
            }); 
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },
    view (id) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/show_product", {
          params: {
            username: this.username,
            token: this.token,
            id: id,
            
          }
        })
        .then(res => {
          this.loading = false;
          console.log()
          if (res.data.status == "success") {
            this.tableInfo = res.data.data
          }
        }); 
    },
    seach() {
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/shopProductList", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            page,
            limit: this.limit,
            check: 0,
            shop_name: this.s_shop_name,
            title: this.s_name,
            item_no: this.s_item_no
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.tableData = res.data.data.results;
            this.total = res.data.data.total;
            this.page = res.data.data.page;
          }else if(res.data.code == '403'){
            this.role = false;  
          }else{
            this.tableData = [];
          }
        });
    },
     shopSearchList() {
      this.axios
        .get(this.serve + "/admin/shopSearchList", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
     
          if (res.data.status == "success") {
            
            var arr = [];
            for(var vs of res.data.data){
               arr.push(vs);
            }
            this.options = arr;
            console.log(arr);
          }
        });
    }
  }
};
</script>
<style lang="scss">
.el-form-item{
  margin-bottom:0px;
}
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
    width: 85%;
    float: right;
  }
  .mutiAuth{
    margin: 14px;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
    padding-top: 6px;;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
  .firstline th:first-child .cell .el-checkbox__input:after{
     content: '全选';
     padding: 3px;
  }
}
</style>